import styled from '@emotion/styled'

import { Avatar } from 'shared/ui'

export default styled(Avatar)`
  float: left;
  margin-right: ${props => props.theme.spacing['6']};
`
